document.addEventListener("DOMContentLoaded", () => {

    // CHECK IF ELEMENT HAS BEEN RENDERED
    const waitForElement = (selector) => new Promise((resolve) => {
        const observer = new MutationObserver((mutations, me) => {
            const element = document.querySelector(selector);
            if (element) {
                me.disconnect(); // stop observing
                resolve(element);
            }
        });
        observer.observe(document.documentElement, {
            childList: true,
            subtree: true
        });

        return document.querySelector(selector); 
    });

    // CHECK IF ELEMENT EXISTS AND TRIGGER EVENT
    waitForElement('#product-form-addon').then((selector) => {
        document.dispatchEvent(new CustomEvent("load-availability"))
    })

    // RENDER JS INSIDE A VUE COMPONENT
    document.addEventListener('load-availability', function (event) {
        let placement = document.querySelector("#load-availability")
        let productID = placement.dataset.productId
        let productName = placement.dataset.productName
        let baseURL = placement.dataset.baseUrl
        
        if (theme && theme.StoreAvailability && placement) {
            const child = document.createElement('div')
            child.setAttribute('data-store-availability', '')
            child.setAttribute('data-product-name', productName)
            child.setAttribute('data-base-url', baseURL)
            placement.appendChild(child)
            const storeAvail = new theme.StoreAvailability(child)
            storeAvail.updateContent(productID)
        }
    })
});
